import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import GoBackPage from "./GoBackPage";
import ModalWrapper from "./ModalWrapper";
import { isBrowser } from "react-device-detect";
import GoBackPageForWeb from "../GoBackPageForWeb";
import { STATUS_ENQUIRY_RESPONSE_CODE } from "./constant";
import { useSelector } from "react-redux";


const ProcessingPaymentScreen = ({
  setScreen,
  checkStatus,
}) => {
  const [showGoBackScreen, setShowGoBackScreen] = useState(false);
  let timerForPendingStatus;
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    timerForPendingStatus = setTimeout(() => {
      setScreen("PENDING_STATUS");
    }, 60000);
    return () => {
      clearTimeout(timerForPendingStatus);
    };
  }, []);

  useEffect(() => {
    checkStatus()

  }, []);
  return (
    <ModalWrapper>
      <div className="processing-payment-container">
        <div className="processing">
          <div className="loader-processing">
            <Loader
              type="TailSpin"
              color="var(--primary-theme-color)"
              height={50}
              width={50}
              timeout={600000}
            />
          </div>
          <p className="headingTakingTime">It’s Taking Longer Than Usual</p>
          <p className="headingTakingTimeText">
            Please wait while we get an update form your bank
          </p>
        </div>
        <div
          role="button"
          tabIndex={-1}
          className="cancel-payment-button"
          onClick={() => setShowGoBackScreen(true)}
        >
          Go Back
        </div>
        {showGoBackScreen &&
          (isBrowser ? (
            <GoBackPageForWeb
              onClose={() => setShowGoBackScreen(false)}
              setScreen={setScreen}
            />
          ) : (
            <GoBackPage
              onClose={() => setShowGoBackScreen(false)}
              setScreen={setScreen}
            />
          ))}
      </div>
    </ModalWrapper>
  );
};
export default ProcessingPaymentScreen;
